import React, { Component } from 'react'

import { defaultTransactionFieldsValues } from '../scripts/cielo/constraints';

export const ContextDebit = React.createContext({});

export class ContextDebitProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tokenDebit: '',
      bodyDebit: {
        ...defaultTransactionFieldsValues,
  
        cardexpirationmonth: '',
        cardexpirationyear: '',
        cardnumber: '',
        ordernumber: '',
      },
      tokenInit: '',
    }

    this.setTokenDebit = (tokenDebit) => {
      this.setState(prevState => ({ ...prevState, tokenDebit }));
    }

    this.setBodyDebit = (bodyDebit) => {
      this.setState(prevState => ({ ...prevState, bodyDebit }));
    }

    this.setTokenInit = (tokenInit) => {
      this.setState(prevState => ({ ...prevState, tokenInit }));
    }
  }

  render() {
    const { children } = this.props;
    const { tokenDebit, bodyDebit, tokenInit } = this.state;
    const { setTokenDebit, setBodyDebit, setTokenInit } = this;

    return (
      <ContextDebit.Provider
        value={{
          tokenDebit, setTokenDebit,
          bodyDebit, setBodyDebit,
          tokenInit, setTokenInit
        }}
      >
        {children}
      </ContextDebit.Provider>
    )
  }
}
